import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TwoFAType } from '../types'

type ChallengeType = { challengeId: string; twoFaType: TwoFAType }

export type SecondFactorChallengeState = {
  creating: boolean
  current?: ChallengeType
  error: boolean
}

export const initialState: SecondFactorChallengeState = {
  creating: false,
  error: false
}

const configSlice = createSlice({
  initialState,
  name: 'secondFactorChallenge',
  reducers: {
    createChallenge() {},
    setCreateChallenError(state, action: PayloadAction<boolean>) {
      state.error = action.payload
    },
    setCurrenctChallenge(state, action: PayloadAction<ChallengeType>) {
      state.current = action.payload
    },
    setFetching(state, action: PayloadAction<boolean>) {
      state.creating = action.payload
    }
  }
})

export const { actions } = configSlice
export default configSlice.reducer
